import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { VeiculoService } from '../services/veiculo.service';
import { ProfissionalService } from '../services/profissional.service';


@Component({
	selector: 'app-dashboard-operacao',
	templateUrl: './dashboard-operacao.component.html',
	styleUrls: ['./dashboard-operacao.component.css'],
	animations: [loadingFade, modal, alert]
})
export class DashboardOperacaoComponent implements OnInit {
	public loading;
	public condutores = [];
	public veiculos = [];

	// paginacao condutores
	public page_cond = 1;
	public limit_cond = 10;
	public count_cond = 0;
	
	// paginacao veiculos
	public page_veic = 1;
	public limit_veic = 10;
	public count_veic = 0;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;

	constructor(private authSvc:AuthService,
		private veiculoSvc:VeiculoService,
		private profissionalSvc:ProfissionalService,
		) { }
	
	ngOnInit(){


		this.usuario_perfil = this.authSvc.getPerfil();

		if(this.usuario_perfil == 2){
			this.pegaCondutores();
		}else{
			this.pegaCondutoresPorUnidade();
		}
		
		this.pegaVeiculos();
	}

	pegaCondutores(){
		this.loading = true;
		this.profissionalSvc.getCondutoresByUsuario(this.authSvc.getUsuarioId()).then((data:any) => {
			this.condutores = data;
			this.count_cond = this.condutores.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}


	pegaCondutoresPorUnidade(){
		this.loading = true;
		this.profissionalSvc.getCondutoresByUsuarioPorUnidade(this.authSvc.getUsuarioId()).then((data:any) => {
			this.condutores = data;
			this.count_cond = this.condutores.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	pegaVeiculos(){
		this.loading = true;
		this.veiculoSvc.getVeiculosDashboard(this.authSvc.getUsuarioId()).then((data:any) => {
			this.veiculos = data;
			this.count_veic = this.veiculos.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	primPagina(table_name) {
		switch(table_name){
			case 'cond':
				this.page_cond = 1;
				break;
			case 'veic':
				this.page_veic = 1;
				break;
		}
	}

	paginaAnt(table_name) {
		switch(table_name){
			case 'cond':
				this.page_cond = Math.max(this.page_cond - 1, 1);
				break;
			case 'veic':
				this.page_veic = Math.max(this.page_veic - 1, 1);
				break;
		}
	}

	proxPagina(table_name) {
		switch(table_name){
			case 'cond':
				this.page_cond = Math.min(this.page_cond + 1, Math.ceil(this.count_cond / this.limit_cond));
				break;
			case 'veic':
				this.page_veic = Math.min(this.page_veic + 1, Math.ceil(this.count_veic / this.limit_veic));
				break;
		}
	}

	ultPagina(table_name) {
		switch(table_name){
			case 'cond':
				this.page_cond = Math.ceil(this.count_cond / this.limit_cond);
				break;
			case 'veic':
				this.page_veic = Math.ceil(this.count_veic / this.limit_veic);
				break;
		}
	}
}
